<app-card></app-card>

<div class="container" style="margin-bottom: 0;margin-top:3%;margin: 3rem; border: 1px solid #0076ce; ">
    <h2 class="dds__h2" style="font-weight: bold;margin: 1rem;">Part OS-Lang Matrix
    </h2>
    <div *ngIf="isLoading" style="margin-top: 3rem; margin-bottom: 5rem; display: flex; justify-content: center;">
        <svg style="height: 32px; width: 32px;"> <use xlink:href="#dds__loading-sqrs"></use>
        </svg>
    </div>
    <div *ngIf="!isLoading && !errorLoading" class="dds__card_ed" style=" margin-top: 2rem; margin: 1rem;">
    <div class="dds__card_ed" style=" margin-top: 2rem; margin: 1rem;">
        <div class="dds__form-check" style="margin-left: 82%" >
            <label class="dds__form-check-label" for="osLangRequired">
              <input type="checkbox" id="osLangRequired" name="osLangRequired" class="dds__form-check-input" [(ngModel)] = "osLangRequired">
              <span>OS-Lang Matrix Required</span>
            </label>
          </div>
    <div class="dds__card_ed" style=" margin-top: 2rem; margin: 1rem;">
        <div class="tableFixHead">
            <form [formGroup]="osLangMatrixForm">
            <table id="tbl_bgr" style="border-collapse: unset;">
                <thead>
                    <tr>
                        <th>Operating Systems <br>                   
                            <input type="text"  class="dds__form-control" 
                            style="margin-bottom: 1rem; width: 100%;"       
                            (ngModelChange)="filterOSItem($event)" 
                            [(ngModel)]="filterOSText" [ngModelOptions]="{standalone: true}" placeholder="Search Operating System"></th>
                        <th>Languages <br>
                            <input type="text"  class="dds__form-control" 
                            style="margin-bottom: 1rem; width: 100%;"       
                            (ngModelChange)="filterLangItem($event)" 
                            [(ngModel)]="filterLangText" [ngModelOptions]="{standalone: true}" placeholder="Search language">
                        </th>
                        <th></th>
                        <th>OS-Lang Matrix<br>
                            <input type="text"  class="dds__form-control" 
                            style="margin-bottom: 1rem; width: 100%;"       
                            (ngModelChange)="filterOSLangItem($event)" 
                            [(ngModel)]="filterOSLangText" [ngModelOptions]="{standalone: true}" placeholder="Search OS-Lang Matrix">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="width: 35%;">
                                <select #selectOSList name="OS" id="os" multiple style="width: 100%; min-height:200px;" formControlName="operatingSystem" >
                                    <option *ngFor="let operatingSystem of operatingSystems" [value]="operatingSystem">{{operatingSystem}}</option>
                                </select>
                        </td>
                        <td style="width: 20%;">
                                <select #selectLangList name="Language" id="language" multiple style="width: 100%; min-height:200px;" formControlName="language">
                                    <option *ngFor="let language of Languages" [value]="language">{{language}}</option>
                                </select>
                        </td>
                        <td style="width: 5%; text-align: center;">
                                <div >
                                    <a href="javascript:void(0)" style="width: 30%; text-decoration: none;" >
                                        <i style="font-size: 1.5em; color: #006bbd;" tabindex="-1" role="button" aria-label="Add child"
                                        class="clickable dds__icons dds__arrow-tri-left bowtie-icon dds__icon-grid-item"
                                        aria-describedby="vss_21" (click) = "unSelectOSLangValues()"></i> 
                                    </a>
                                    <a href="javascript:void(0)" style="width: 30%; text-decoration: none;" >
                                        <i style="font-size: 1.5em; color: #006bbd;" tabindex="-1" role="button" aria-label="Add child"
                                            class="clickable dds__icons dds__arrow-tri-right bowtie-icon dds__icon-grid-item"
                                            aria-describedby="vss_21" (click) = "selectOSLangValues()"></i>
                                    </a>
                            
                                </div>
                        </td>
    
                        <td style="width: 45%;">
                                <select #selectOSLangList name="oslangmatrix" (ngModelChange)="onChangeOfOptionsOSLang($event)" id="oslangmatrix" multiple style="width: 100%; min-height:200px;" formControlName="osLangMatrix">
                                    <option *ngFor="let PartOsLangSelection of PartOsLangSelections" [value]="PartOsLangSelection">{{PartOsLangSelection}}</option>
                                </select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
        </div>
        <br>
        <div class="text-center" style="display: flex; justify-content: flex-end;">
            <button type="button"
                class="dds__btn dds__btn-primary  dds__text-truncate" (click) = "confirmOSLangValues()">Confirm
            </button>&nbsp;
            <button type="button" data-dismiss="dds__modal" aria-label="Close" class="dds__close" (click) ="onCancel()"
               class="dds__btn dds__btn-secondary dds__text-truncate" >Cancel
            </button>
    
        </div>
    </div>
</div>
</div>

<div *ngIf="!isLoading && errorLoading" >
    <p style="text-align: center; font-weight: bold;margin: 4rem;color: var(--dell-red);">{{errorLoadingMsg}}</p>
</div>


  